import { render, staticRenderFns } from "./ButtonItem.vue?vue&type=template&id=0508c606&scoped=true&"
import script from "./ButtonItem.vue?vue&type=script&lang=js&"
export * from "./ButtonItem.vue?vue&type=script&lang=js&"
import style0 from "./ButtonItem.vue?vue&type=style&index=0&id=0508c606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508c606",
  null
  
)

export default component.exports